import React from "react";
import { Navigate } from "react-router-dom";

// publicRoutes...................
import Login from "../pages/Auth/Login";
import PageNotFound from "../pages/404/PageNotFound";

// authProtectedSpoc..............
import Dashboard from "../pages/Dashboard";
import Internship from "../pages/Internship";
// import Company from "../pages/Company";
import Placement from "../pages/Placement";
import Resume from "../pages/Resume";
import Support from "../pages/Support";
import AcademyProgram from "../pages/AcademyProgram";
import InstitutionStatus from "../pages/InstitutionStatus";
import CorporateProgram from "../pages/CorporateProgram";
import Educator from "../pages/Educator";
import NewsEvents from "../pages/News&Events";
import Publication from "../pages/Publication";
import AwardsRecognition from "../pages/Awards&Recognition";

import Settings from "../pages/Auth/Settings";
import InternshipApproval from "../pages/Internship/InternApproval";
// import Membership from "../pages/Membership";
import TalentConnect from "../pages/TalentConnect";
import Agreements from "../pages/Membership/agreements";
// import Payment from "../pages/Membership/payment";
import InstitutionalProfile from "../pages/Membership/InstitutionalProfile/InstitutionalProfile";
import FeedbackForm from "../pages/Feedback";
// Admin
import AdminEducator from "../pages/Admin/Educator";
import Academy from "../pages/Admin/Academy";
import Institute from "../pages/Admin/Institute";
import ProgramAssign from "../pages/Admin/Program Assign/programAssign"; //pratyukticode
import AdminStaff from "../pages/Admin/Staff";
import AdminStudentReport from "../pages/Admin/Student/AdminStudentReport";
import CorporateStudentReport from "../pages/Admin/Student/CorporateStudentReport";
import ApplicationsPage from "../pages/TalentConnect/ApplicationsPage";
import JobDescriptionPage from "../pages/TalentConnect/JobDescriptionPage";
import JobPostPage from "../pages/TalentConnect/JobPostPage";
import CompanyPage from "../pages/TalentConnect/CompanyPage";
import Notification from "../pages/Notifications";
import Apsche from "../pages/Certificate/Apsche Certificate/Apsche";
import StaffEvent from "../pages/staffevent/StaffEvent";
import EventForm from "../pages/Admin/Event/EventForm";
import InternshipAll from "../pages/StudentInfo/InternshipAll";
import EmailDraft from "../pages/EmailDraft/EmailDraft";
import ExternalRedirect from "./ExternalRedirect";
import TailLogin from "../pages/Auth/TailLogin";
import LayoutInfo from "../pages/StudentInfo/LayoutInfo";
import InteractiveIndiaMap from "../pages/Map/InteractiveIndiaMap";
import PDFViewer from "../pages/StudentInfo/PDFviewer";
import MaterialExcelInterface from "../pages/StudentInfo/ExcelPasteInterface";
import SpocDashboard from "../pages/spoc dashboard/Dashboard";
import JobsApps from "../pages/talentconnectspoc/JobApps";
import InternshipTrackingTable from "../components/spocstatus/InternshipTrackingTable";
import MembersList from "../components/spocstatus/Faculty Database/MembersList";
import CohortDashboard from "../components/StaffSection/NewStatus/CohortDashboard";
import CheckboxSidebar from "../pages/sidebar/CheckboxSidebar";
import ComingSoonPage from "../components/comingsoon/ComingSoon";
import StudentStatusApp from "../components/studentstatus";
import SubscriptionDashboard from "../pages/subscription/Subscription";
import IntakeData from "../pages/StudentInfo/IntakeData";
import ReportSidebar from "../pages/reportsidebar/ReportSidebar";
import KnowledgeHubPage from "../pages/1guide/KnowledgehubPage";
import FilterForm from "../components/Applied/ReportAll";
import AnnouncementPage from "../pages/Announcement/Announcement";
import NewSidebar from "../pages/sidebar/NewSidebar";
import FDPManagement from "../pages/Trainer FDP/FDPManagement";
import TicketRaiseComponent from "../pages/TicketRaise/TicketRaiseComponent";
import AdminTicketManagement from "../pages/TicketRaise/AdminTicketManagement";
import SupportTicketManagementSystem from "../pages/supports/SupportTicketManagementSystem";
import JobListingApp from "../pages/TConnect/JobListingApp";
import FDPDetails from "../pages/Trainer FDP/FDPDetails";
import FDPParticipantsView from "../pages/Trainer FDP/FDPParticipants";
import TalentConnectDashboard from "../pages/TConnect/TalentConnectDashboard";
import MainSidebar from "../pages/mainsidebar/MainSidebar";
import ReportsLayout from "../components/New Report/ReportsLayout";
import NewMaterialExcelInterface from "../pages/StudentInfo/NewExcelPasteInterface";
import InstituteProfileView from "../pages/InstituteProfile/InstituteProfileDisplay";
import ManageUser from "../pages/mainsidebar/ManageUser";
import ProcessViewer from "../components/StudentSteps/StudentStep";
import InstituteProfile from "../pages/InstituteProfile/NewEducationForm";
import InstituteProfileDisplay from "../pages/InstituteProfile/InstituteProfileDisplay";
import NewTotalInternship from "../components/dashboard/InternshipSection/NewTotalInternship";
import StaffSidebar from "../pages/mainsidebar/StaffSidebar";
import FigmaStyleEditor from "../components/manage/FigmaStyleEditor";
import Deleted from "../components/Deleted/Deleted";
import EventDashboard from "../components/Event/EventDashboard";
import EduSkillsLoader from "../components/1Loader/EduSkillsLoader";
import MultiStepForm from "../components/1Loader/MultiForm";
import ProfilePage from "../components/Event/ProfileEditDrawer";
import SubDashboard from "../pages/subscription/SubDashboard";
import MembershipTable from "../pages/subscription/Subscription";
import NewSubs from "../pages/subscription/NewSubs";
import CompactRMForm from "../pages/1BDFrom/CompactRMForm";
import CollegeDataTable from "../pages/1BDFrom/CollegeDataTable";
import CombinedTableDrawer from "../pages/1BDFrom/CombinedTableDrawer";
import StaffManageUser from "../pages/mainsidebar/StaffManageUser";
import Archived from "../components/Archive/Archived";
import AwardsAccordion from "../pages/Connect25/AwardsAccordion";
import PersonalInfoForm from "../pages/Connect25/Nomination/NominationForm";
import PlacementMultiStepForm from "../pages/Connect25/tponomination/PlacementForm";
import MaintenancePage from "../pages/mainsidebar/Maintenancepage";
import AwardManagementSystem from "../pages/Admin/NominationMarking/AwardManagementSystem";
import MainVotingApp from "../pages/Trainer FDP/Example/MainVotingApp";
import MainCorporate from "../pages/Connect25/CorporateVoting/MainCorporate";
import Agenda from "../pages/AdminAgenda/Addagenda";
import FeedbackTable from "../pages/Admin/NominationMarking/FeedbackTable";
import FormBuilder from "../pages/Trainer FDP/FormBuilder";
import ConnectRegistrations from "../pages/Admin/NominationMarking/ConnectRegistrations";
import { BadgeCard } from "../pages/Connect25/BadgeCard";
import QRCodeScanner from "../Layouts/top/QrCodeScanner";
import EventQRPlanner from "../pages/Connect25/qrcode/EventQR";
import WinnerBanner from "../pages/Connect25/qrcode/WinnerBanner";
import ModernCalendar from "../pages/Trainer FDP/Slots/ModernCalendar";
import AttendanceSystem from "../pages/Trainer FDP/Slots/AttendanceSystem";
import TechCampStudentsView from "../pages/Trainer FDP/Slots/TechCampStudentsView";
import FDPFacultyView from "../pages/Trainer FDP/Slots/FDPFacultyView";
import ConferenceTicketGenerator from "../pages/Trainer FDP/Slots/ConferenceTicketGenerator";
import CalendarApp from "../pages/Trainer FDP/Calendars/CalendarApp";
import TrainerManagement from "../pages/Trainer FDP/TrainerAdd/TrainerManagement";
import AdminTrainerAvailabilityCalendar from "../pages/Trainer FDP/Calendars/AdminTrainerAvailabilityCalendar";
import BookingCalendar from "../pages/Trainer FDP/spocevent/BookingCalendar";
import EventFeedbackForm from "../pages/Admin/NominationMarking/EventFeedbackForm";
import FeedbackTables from "../pages/Trainer FDP/Example/FeedbackTable";
import AdminSupportDashboard from "../pages/Itsupport/AdminSupportDashboard";
import StudentQuestionsHistory from "../pages/Itsupport/StudentQuestionsHistory";
import ITSupportStaff from "../pages/Admin/itsupport/ITSupportStaff";
import SupportDashboard from "../pages/Admin/itsupport/SupportDashboard";
import Tickets from "../pages/Itsupport/Tickets";
import EventTabsComponent from "../pages/Connect25/EventTabsComponent";
import SpocEvents from "../pages/Trainer FDP/SpocEvent";
import TechCampsTable from "../pages/Trainer FDP/spocevent/Certificate/TechCampCertificate";
import DomainManagement from "../pages/supports/DomainManagement";
import WeekManagement from "../pages/supports/WeekManagement";
import Modules from "../pages/supports/Modules";
import StudentPreview from "../pages/supports/StudentPreview";
import ProductManagement from "../pages/supports/ProductManagement";
import AwardsByCategory from "../pages/Connect25/AwardsByCategory";
import SearchStudent from "../pages/Suport_Student/SearchStudent";
import StudentDashboard from "../pages/Suport_Student/StudentSupportDashboard";
import IntershipDetailTable from "../pages/Suport_Student/IntershipDetailTable";
import StaffTrainerAvailability from "../pages/Trainer FDP/Example/StaffTrainerAvailability";
import EventHistory from "../pages/Trainer FDP/Example/EventHistory";
import OnboardingForm from "../pages/staffevent/OnboardingForm";
import OnboardingManagement from "../pages/staffevent/OnboardingManagement";
import FacultyEventTable from "../pages/Trainer FDP/spocevent/FDPEDP/FacultyEventTable";
import BookingsList from "../pages/Trainer FDP/Calendars/BookingsList";
import TechCamp from "../pages/Trainer FDP/Calendars/TechCamp";
import FDPEvent from "../pages/Trainer FDP/Calendars/FDPEvent";
import EDPEvent from "../pages/Trainer FDP/Calendars/EDPEvent";
import EDPBookCalendar from "../pages/Trainer FDP/Calendars/EDPBookCalendar";
import ZohoTabs from "../pages/Trainer FDP/TrainerAdd/DashboardComponent";
import TabActivity from "../pages/Trainer FDP/spocevent/TabActivity";
import SpocPrerequisitesDocuments from "../pages/Trainer FDP/spocevent/SpocPrerequisitesDocuments";
import EducatorEvent from "../pages/Educator/Acitvities/EducatorEvent";
import CarouselEditor from "../pages/Trainer FDP/Example/CarouselEditor";
import ElegantCarousel from "../pages/Trainer FDP/Example/ElegantCarousel";
import FacultyEventsTable from "../pages/Educator/Acitvities/FacultyEventsTable";
import FacultyEventsPage from "../pages/Educator/FacultyEventsPage";
import ProcessPage from "../pages/Educator/ProcessPage";
import MembershipFormSystem from "../pages/Trainer FDP/Example/MembershipFormSystem";
import InstituteRegistrationForm from "../pages/Trainer FDP/Example/InstituteRegistrationFrom";
import TemplateList from "../pages/ScheduleEmail/TemplateList";
import ScheduleEmail from "../pages/ScheduleEmail/ScheduleEmail";
import EmailTemplateEditor from "../pages/ScheduleEmail/EmailTemplateEditor";
import UploadCertificate from "../pages/Educator/UploadCertificate";
import TpoDashboard from "../components/tpo/dashboard";
import TpoEvent from "../components/tpo/tpoevent";

import MembershipForm from "../pages/Trainer FDP/Example/MembrshipCreation";
import CreateFeatureComponent from "../pages/Trainer FDP/Example/CreateFeature";
import InvoiceForm from "../pages/Trainer FDP/Example/InvoiceForm";
import ImageEditor from "../pages/Trainer FDP/Example/ImageEditor copy";
import PosterManagement from "../pages/Trainer FDP/Example/PosterManagement";
import Announcement from "../pages/Admin/LoginAnnouncement/Announcement";
import FdpDashboard from "../pages/Trainer FDP/Example/FdpDashboard";
import EdpDashboard from "../pages/Trainer FDP/Example/EdpDashboard";
import TechCampDashboard from "../pages/Trainer FDP/Example/TechCampDashboard";
import InstituteSummaryTable from "../components/Admin/StaffInstituteSummary";
// import ColumnSelector from "../components/New Report/ColumnSelector";
import StaffDashboard from "../pages/Admin/Staff/Staffdasgboard";
import StaffGoogleMeetPage from "../pages/Admin/Staff/StaffGoogleMeetPage";
import InstituteTicket from "../pages/Itsupport/Instituteticket";
import TicketManagementTable from "../pages/Staff/TicketManagementTable";
import StaffQuestionsHistory from "../pages/Staff/StaffQuestionsHistory";
import CareerTalk_staff from "../pages/Trainer FDP/Example/CareerTalk_staff";
import MembershipManager from "../pages/Trainer FDP/Example/MemCreation/MembershipManager";
import InstituteMemberships from "../pages/Trainer FDP/Example/InstitutesMemberships";
import FileManager from "../pages/supports/FileManager";
import Advannouncement from "../pages/Announcement/Advannouncement";
import SubscriptionDetails from "../services/SubDetails";
import FacultyPricing from "../pages/subscription/FacultyPricing";
import MyAssignedTickets from "../pages/Itsupport/AssignedTickets";
import TrainerInterestsTable from "../pages/Trainer FDP/TrainerAdd/TrainerFDPInterestStatus";
import RisingStar from "../pages/Desiner/risingstar";
import UpcomingEvents from "../pages/Desiner/UpcomingEvents";
import GlobalEducationPage from "../pages/GlobalEducation/GlobalEducationPage";
import TechCampEventTable from "../pages/Trainer FDP/spocevent/FDPEDP/TechCampEventTable";
import ChatbotAdminPanel from "../components/ChatbotAdminPanel";
import ChatbotStudent from "../components/Chatbotstudent";
import CoeAdmin from "../pages/Admin/COE/CoeAdmin";
import CoeAdminDomains from "../pages/Admin/COE/CoeAdminDomains";
import CoeAdminFeatures from "../pages/Admin/COE/CoeAdminFeatures";
import CoeAdminTypes from "../pages/Admin/COE/CoeAdminTypes";
import CoeAdminDocuments from "../pages/Admin/COE/CoeAdminDocuments";
import LeadersSpocsFacultyPage from "../pages/Staff/Leadersspocsfacultypage";
import SpocRoleAccess from "../pages/SpocAccess/SpocRoleAccess";
import Achievement from "../pages/Achievement/Achievement";
import AdminMagazines from "../pages/Admin/magazin/AdminMagazines";
import AdminMagazineForm from "../pages/Admin/magazin/AdminMagazineForm";
import AdminMagazineDashboard from "../pages/Admin/magazin/AdminMagazineDashboard";
import TrainerDocumentEditor from "../pages/Trainer FDP/TrainerDocumentEditor";
import GuideBook from "../pages/Guide/GuideBook";
import Help from "../pages/Guide/Help";
const authProtected = [
  {
    path: "/dashboard",
    component: <Dashboard />,
    roles: [
      "spoc",
      "manager",
      "management",
      "educator",
      "account_manager",
      "talent_module",
      "admin",
      "staff",
      "talent",
      "leaders",
      "dspoc",
      "trainer",
      "support",
      "accounts",
      "trainerspoc",
      "desiner",
      "corporate",
      "business_development_manager"
    ],
  },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

//

const authProtectedRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
    roles: [
      "spoc",
      "manager",
      "management",
      "educator",
      "account_manager",
      "talent_module",
      "admin",
      "staff",
      "talent",
      "leaders",
      "dspoc",
      "tpo",
      "trainer",
      "support",
      "accounts",
      "trainerspoc",
      "desiner",
      "corporate",
      "business_development_manager"
    ],
  },
  {
    path: "/tpo-dashboard",
    component: <TpoDashboard />,
    roles: ["tpo", "spoc"],
  },
  {
    path: "/spoc-role-access",
    component: <SpocRoleAccess />,
    roles: ["spoc"],
  },
  {
    path: "/achievement",
    component: <Achievement />,
    roles: ["spoc"],
  },
  {
    path: "/trainer-document-editor",
    component: <TrainerDocumentEditor />,
    roles: ["trainer"],
  },

  {
    path: "/feedback",
    component: <FeedbackForm />,
    roles: [
      "spoc",
      "manager",
      "management",
      "educator",
      "account_manager",
      "admin",
    ],
  },
  {
    path: "/settings",
    component: <Settings />,
    roles: [
      "spoc",
      "manager",
      "management",
      "educator",
      "account_manager",
      "admin",
      "staff",
    ],
  },

  {
    path: "/internship",
    component: <MainSidebar />,
    roles: [
      "spoc",
      "manager",
      "management",
      "educator",
      "account_manager",
      "admin",
      "staff",
    ],
  },

  // {
  //   path: "/company",
  //   component: <Company />,
  //   roles: ["talent_module"],
  // },

  {
    path: "/placement",
    component: <Placement />,
    roles: ["talent_module"],
  },
  {
    path: "/internship-approval",
    component: <InternshipApproval />,
    roles: ["spoc"],
  },
  {
    path: "/sidebar-checkbox",
    component: <CheckboxSidebar />,
    roles: ["spoc"],
  },
  {
    path: "/apsche-certificate",
    component: <Apsche />,
    roles: ["spoc"],
  },
  {
    path: "/internship-all",
    component: <LayoutInfo />,
    roles: ["spoc"],
  },
  {
    path: "/total-staff",
    component: <NewTotalInternship />,
    roles: ["staff"],
  },
  {
    path: "/student-staff",
    component: <StaffManageUser />,
    roles: ["staff"],
  },
  {
    path: "/leaders-spocs-faculty",
    component: <LeadersSpocsFacultyPage />,
    roles: ["staff"],
  },
  {
    path: "/internship-all-staff",
    component: <StaffSidebar />,
    roles: ["staff"],
  },
  {
    path: "/institute-summary-staff",
    component: <InstituteSummaryTable />,
    roles: ["staff"],
  },

  {
    path: "/interactive",
    component: <InteractiveIndiaMap />,
    roles: ["spoc"],
  },
  {
    path: "/pfile",
    component: <ProfilePage />,
    roles: ["spoc"],
  },
  {
    path: "/archived",
    component: <Archived />,
    roles: ["spoc"],
  },

  {
    path: "/figma",
    component: <FigmaStyleEditor />,
    roles: ["spoc"],
  },
  {
    path: "/coming-soon",
    component: <ComingSoonPage />,
    roles: ["spoc", "dspoc", "leaders", "business_development_manager"],
  },
  {
    path: "/student-status",
    component: <StudentStatusApp />,
    roles: ["spoc"],
  },
  {
    path:"/adminchatbot",
    component:<ChatbotAdminPanel />,
    roles:["support"]
  },
  {
    path:"/studentchatbot",
    component:<ChatbotStudent />,
    roles:["support"]
  },
  {
    path: "/subscription",
    component: <NewSubs />,
    roles: ["spoc", "dspoc", "leaders", "tpo"],
  },
  {
    path: "/new-report",
    component: <FilterForm />,
    roles: ["spoc"],
  },
  {
    path:"/globalprogram",
    component:<GlobalEducationPage />,
    roles:["staff"]

  },
  {
    path: "/loader",
    component: <EduSkillsLoader />,
    roles: ["spoc", "dspoc", "leaders"],
  },
  {
    path: "/multi",
    component: <AwardsAccordion />,
    roles: ["spoc", "dspoc", "leaders", "tpo", "staff","educator"],
  },
  {
    path: "/maintenance",
    component: <MaintenancePage />,
    roles: ["spoc", "dspoc", "leaders", "tpo"],
  },

  // {
  //   path: "/award",
  //   component: <PersonalInfoForm />,
  //   roles: ["spoc", "dspoc", "leaders", "tpo"],
  // },
  {
    path: "/event",
    component: <EventDashboard />,
    roles: ["spoc"],
  },
  {
    path: "/event",
    component: <TpoEvent />,
    roles: ["tpo"],
  },
  {
    path: "/student-step",
    component: <ProcessViewer />,
    roles: ["spoc"],
  },
  {
    path:"/risingstar",
    component:<RisingStar />,
    roles:["desiner"]
  },

  // {
  //   path: "/email-draft",
  //   component: <EmailDraft />,
  //   roles: ["spoc"],
  // },
  {
    path: "/resume",
    component: <Resume />,
    roles: ["talent_module"],
  },

  // {
  //   path: "/admin-events",
  //   component: <EventForm />,
  //   roles: ["admin"],
  // },

  {
    path: "/support",
    component: <Support />,
    roles: ["spoc", "manager", "talent_module", "educator", "admin"],
  },

  // Admin..........................................

  {
    path: "/schedule_email",
    component: <TemplateList />,
    roles: ["admin"],
  },
  {
    path: "/new_schedule_email",
    component: <ScheduleEmail />,
    roles: ["admin"],
  },
  {
    path: "/email_builder",
    component: <EmailTemplateEditor />,
    roles: ["admin"],
  },

  {
    path: "/academy",
    component: <Academy />,
    roles: ["admin"],
  },
  {
    path: "/support staff",
    component: <ITSupportStaff />,
    roles: ["admin"],
  },
  {
    path: "/admin-coe",
    component: <CoeAdmin />,
    roles: ["admin"],
  },
  {
    path: "/admin-coe/:academyId",
    component: <CoeAdminDomains />,
    roles: ["admin"],
  },
  {
    path: "/admin-coe/:academyId/:domainId",
    component: <CoeAdminFeatures />,
    roles: ["admin"],
  },
  {
    path: "/admin-coe/:academyId/:domainId/coe",
    component: <CoeAdminTypes />,
    roles: ["admin"],
  },
  {
    path: "/admin-coe/:academyId/:domainId/coe/:docType",
    component: <CoeAdminDocuments />,
    roles: ["admin"],
  },
  {
    path: "/admin/magazines",
    component: <AdminMagazines />,
    roles: ["admin"],
  },
  {
    path: "/admin/magazines/create",
    component: <AdminMagazineForm />,
    roles: ["admin"],
  },
  {
    path: "/admin/magazines/edit/:id",
    component: <AdminMagazineForm />,
    roles: ["admin"],
  },
  {
    path: "/admin/magazines/:id/manage",
    component: <AdminMagazineDashboard />,
    roles: ["admin"],
  },
  {
    path: "/admin-magazines",
    component: <AdminMagazines />,
    roles: ["admin"],
  },
  {
    path: "/supportdashboard",
    component: <SupportDashboard />,
    roles: ["admin"],
  },
  {
    path: "/getticket",
    component: <Tickets />,
    roles: ["support"],
  },
  {
    path: "/history",
    component: <StudentQuestionsHistory />,
    roles: ["support"],
  },
  {
    path: "/Token",
    component: <AdminSupportDashboard />,
    roles: ["support"],
  },
  {
    //pratyukticode three lines
    path: "/programassign",
    component: <ProgramAssign />,
    roles: ["admin"],
  },
  {
    path: "/institute",
    component: <Institute />,
    roles: ["admin", "staff"],
  },
  {
    path: "/admin-educator",
    component: <AdminEducator />,
    roles: ["admin"],
  },
  {
    path: "/admin-feedback",
    component: <FeedbackTable />,
    roles: ["admin", "business_development_manager"],
  },
  {
    path: "/staff",
    component: <AdminStaff />,
    roles: ["admin", "staff"],
  },
  {
    path: "/admin-student-report",
    component: <AdminStudentReport />,
    roles: ["admin"],
  },
  {
    path: "/corporate-student-report",
    component: <CorporateStudentReport />,
    roles: ["corporate"],
  },
  {
    path: "/announcement-login",
    component: <Announcement />,
    roles: ["admin"],
  },

  // {
  //   path: "/event-details",
  //   component: <StaffEvent />,
  //   roles: ["staff"],
  // },

  // Talent Connect.................................................
  {
    path: "/applications",
    component: <ApplicationsPage />,
    roles: ["talent"],
  },
  {
    path: "/job-description",
    component: <JobDescriptionPage />,
    roles: ["talent"],
  },
  {
    path: "/job-post",
    component: <JobPostPage />,
    roles: ["talent"],
  },
  {
    path: "/company",
    component: <CompanyPage />,
    roles: ["talent"],
  },

  //.................................................

  {
    path: "/academy-program",
    component: <AcademyProgram />,
    roles: ["account_manager", "manager", "educator", "admin", "spoc"],
  },
  {
    path: "/institution-status",
    component: <InstitutionStatus />,
    roles: ["spoc", "manager", "account_manager", "admin"],
  },
  {
    path: "/corporate-program",
    component: <CorporateProgram />,
    roles: ["spoc", "management"],
  },
  {
    path: "/educator",
    component: <Educator />,
    roles: ["spoc", "educator", "management", "staff"],
  },
  {
    path: "/news-events",
    component: <NewsEvents />,
    roles: ["spoc"],
  },
  {
    path: "/publication",
    component: <Publication />,
    roles: ["spoc"],
  },
  {
    path: "/awards-recognition",
    component: <AwardsRecognition />,
    roles: ["spoc"],
  },
  {
    path: "/add-student",
    component: <ManageUser />,
    roles: ["spoc", "dspoc", "leaders"],
  },
  {
    path: "/file-manage",
    component: <FileManager />,
    roles: ["support"],
  },
  {
    path: "/advrtise",
    component: <Advannouncement />,
    roles: ["admin"],
  },
  // {
  //   path: "/vote",
  //   component: <NominationVotingSystem />,
  //   roles: ["spoc", "dspoc", "leaders"],
  // },
  {
    path: "/spocdashboard",
    component: <SpocDashboard />,
    roles: ["spoc"],
  },
  {
    path: "/job-apps",
    component: <JobsApps />,
    roles: ["spoc"],
  },
  {
    path: "/institute-profile",
    component: <InstituteProfile />,
    roles: ["spoc"],
  },
  {
    path: "/rm",
    component: <CompactRMForm />,
    roles: ["staff"],
  },
  {
    path: "/rmd",
    component: <CombinedTableDrawer />,
    roles: ["staff"],
  },

  {
    path: "/institute-profile-view",
    component: <InstituteProfileDisplay />,
    roles: ["spoc"],
  },
  {
    path: "/announcement",
    component: <AnnouncementPage />,
    roles: ["spoc"],
  },
  {
    path: "/internship-tracking",
    component: <InternshipTrackingTable />,
    roles: ["spoc"],
  },
  {
    path: "/membership-list",
    component: <MembersList />,
    roles: ["spoc"],
  },
  {
    path: "/cohort-dash",
    component: <CohortDashboard />,
    roles: ["spoc"],
  },
  {
    path: "/report-sidebar",
    component: <ReportSidebar />,
    roles: ["spoc"],
  },
  {
    path: "/ins-profile",
    component: <InstituteProfileView />,
    roles: ["spoc"],
  },

  // {
  //   path: "/membership",
  //   component: <Membership />,
  //   roles: ["manager", "management", "spoc"],
  // },
  {
    path: "/membership/agreements",
    component: <Agreements />,
    roles: ["manager", "management", "spoc", "admin"],
  },
  // {
  //   path: "/membership/payment",
  //   component: <Payment />,
  //   roles: ["manager", "management", "spoc","admin"],
  // },
  {
    path: "/membership/institutional-details",
    component: <InstitutionalProfile />,
    roles: ["manager", "management", "spoc", "admin"],
  },

  {
    path: "/talent-connect",
    component: <TalentConnectDashboard />,
    roles: ["spoc", "dspoc", "leaders"],
  },
  {
    path: "institute ticket",
    component: <InstituteTicket />,
    roles: ["support"],
  },
  {
    path: "/managestaffticket",
    component: <StaffGoogleMeetPage />,
    role: ["admin"],
  },
  {
    path: "/staff-ticket",
    component: <TicketManagementTable />,
    roles: ["staff"],
  },
  {
    path: "/staticsdashboard",
    component: <StaffDashboard />,
    roles: ["admin"],
  },
  {
    path: "/staff-ticket-history",
    component: <StaffQuestionsHistory />,
    roles: ["staff"],
  },
  {
    path: "/fdp-details",
    component: <FDPDetails />,
    roles: ["spoc"],
  },
  {
    path: "/fdp-view",
    component: <FDPParticipantsView />,
    roles: ["spoc"],
  },
  {
    path: "/ticket",
    component: <TicketRaiseComponent />,
    roles: ["spoc"],
  },
  {
    path: "/admin-ticket",
    component: <AdminTicketManagement />,
    roles: ["spoc"],
  },
  {
    path: "/support-ticket",
    component: <SupportTicketManagementSystem />,
    roles: ["spoc"],
  },
  {
    path: "/notifications",
    component: <Notification />,
    roles: ["spoc", "staff", "admin"],
  },
  {
    path: "/coe",
    component: <PDFViewer />,
    roles: ["spoc","educator"],
  },
  {
    path: "/award-management",
    component: <AwardManagementSystem />,
    roles: ["admin"],
  },
  {
    path: "/trainer-management",
    component: <TrainerManagement />,
    roles: ["admin"],
  },
  {
    path: "/agenda-manage",
    component: <Agenda />,
    roles: ["admin"],
  },
  {
    path: "/connect-reg",
    component: <ConnectRegistrations />,
    roles: ["admin", "staff"],
  },
  {
    path: "/careertalk_staff",
    component: <CareerTalk_staff />,
    roles: ["staff"],
  },
  {
    path: "/delete",
    component: <Deleted />,
    roles: ["spoc"],
  },
  {
    path: "/fdp",
    component: <FDPManagement />,
    roles: ["spoc"],
  },
  {
    path: "/new-sidebar",
    component: <NewSidebar />,
    roles: ["spoc"],
  },
  {
    path: "/event-connect",
    component: <EventTabsComponent />,
    roles: ["admin"],
  },
  {
    path: "/main-sidebar",
    component: <MainSidebar />,
    roles: ["spoc", "dspoc", "leaders","educator"],
  },
  // {
  //   path: "/att",
  //   component: <AttendanceSystem />,
  //   roles: ["spoc", "dspoc", "leaders","trainer"],
  // },
  {
    path: "/tech-camp-calendar",
    component: <TabActivity />,
    roles: ["spoc", "dspoc", "leaders"],
  },
  {
    path: "/tech-camp-certificate",
    component: <TechCampsTable />,
    roles: ["spoc", "dspoc", "leaders"],
  },
  {
    path: "/spoc-event",
    component: <SpocEvents />,
    roles: ["spoc"],
  },
  {
    path: "/spoc-prerequisites",
    component: <SpocPrerequisitesDocuments />,
    roles: ["spoc", "dspoc", "leaders"],
  },
  {
    path: "/ti",
    component: <ConferenceTicketGenerator />,
    roles: ["spoc", "dspoc", "leaders"],
  },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  {
    path: "/Domain",
    component: <DomainManagement />,
    roles: ["support"],
  },
  {
    path: "/Week",
    component: <WeekManagement />,
    roles: ["support"],
  },
  {
    path: "/Modules/:week_id",
    component: <Modules />,
    roles: ["support"],
  },
  {
    path: "/StudentPreview",
    component: <StudentPreview />,
    roles: ["support"],
  },
  {
    path: "/support/products",
    component: <ProductManagement />,
    roles: ["support"],
  },
  {
    path:"/assignticket",
    component:<MyAssignedTickets />,
    roles:["support"],
  },
  {
    path: "/awards",
    component: <AwardsByCategory />,
    roles: ["spoc"],
  },
  {
    path: "/get-student",
    component: <SearchStudent />,
    roles: ["support"],
  },
  {
    path: "/student/:user_id",
    component: <StudentDashboard />,
    roles: ["support"],
  },
  {
    path: "/internship_details/:internship_id",
    component: <IntershipDetailTable />,
    roles: ["support"],
  },
  { path: "/mcalendar", component: <CalendarApp />, roles: ["trainer"] },
  {
    path: "/acalendar",
    component: <StaffTrainerAvailability />,
    roles: ["staff", "admin","trainerspoc"],
  },
  {
    path: "/announcement",
    component: <ImageEditor />,
    roles: ["admin"],
  },
  {
    path: "/preview",
    component: <PosterManagement />,
    roles: ["admin"],
  },
  {
    path: "/att/:bookingId",
    component: <AttendanceSystem />,
    roles: ["trainer"],
  },
  {
    path: "/techcamp-students/:bookingId",
    component: <TechCampStudentsView />,
    roles: ["trainer", "admin"],
  },
  {
    path: "/fdp-faculty/:bookingId",
    component: <FDPFacultyView />,
    roles: ["trainer", "admin"],
  },
  {
    path: "/onboarding",
    component: <OnboardingManagement />,
    roles: ["staff", "admin"],
  },
  {
    path: "/faculty-event",
    component: <FacultyEventTable />,
    roles: ["spoc", "admin"],
  },
  {
    path: "/techcamp-event",
    component: <TechCampEventTable/>,
    roles: ["spoc", "admin"],
  },
  {
    path: "/fdp-event",
    component: <FDPEvent />,
    roles: ["trainer"],
  },
  {
    path: "/techcamp-event",
    component: <ZohoTabs />,
    roles: ["trainer"],
  },
  {
    path: "/my-fdp-interests",
    component: <TrainerInterestsTable />,
    roles: ["trainer"],
  },
  {
    path: "/edp-event",
    component: <EDPBookCalendar />,
    roles: ["trainer"],
  },
  {
    path: "/educator-event",
    component: <FacultyEventsTable />,
    roles: ["educator", "spoc"],
  },
  {
    path: "/faculty-events",
    component: <FacultyEventsPage />,
    roles: ["educator", "spoc", "admin"],
  },
  {
    path: "/process/:domainId/:bookSlotId",
    component: <ProcessPage />,
    roles: ["educator", "spoc"],
    noLayout: true,
  },
  {
    path: "/upload-certificate",
    component: <UploadCertificate />,
    roles: ["educator", "spoc"],
  },
  {
    path: "/institute-creation",
    component: <InstituteRegistrationForm />,
    roles: ["accounts"],
  },
  {
    path: "/institute-registration",
    component: <InstituteMemberships />,
    roles: ["accounts"],
  },
  {
    path: "/create-membership",
    component: <MembershipManager />,
    roles: ["accounts"],
  },
  {
    path: "/create-features",
    component: <CreateFeatureComponent />,
    roles: ["accounts"],
  },
  {
    path: "/invoice-form",
    component: <InvoiceForm />,
    roles: ["accounts"],
  },
  {
    path: "/techcamp_dashboard",
    component: <TechCampDashboard />,
    roles: ["staff", "admin","trainerspoc"],
  },
  {
    path: "/fdp_dashboard",
    component: <FdpDashboard />,
    roles: ["staff", "admin","trainerspoc"],
  },
  {
    path: "/sub-details",
    component: <SubscriptionDetails />,
    roles: ["accounts", "spoc","dspoc","leaders", "educator", "tpo"],
  },
  {
    path: "/edp_dashboard",
    component: <EdpDashboard />,
    roles: ["staff", "admin","trainerspoc"],
  },
  {
    path: "/acalendar",
    component: <StaffTrainerAvailability />,
    roles: ["staff", "admin"],
  },
  {
    path: "/event_history",
    component: <EventHistory />,
    roles: ["admin", "staff", "trainerspoc", "spoc", "trainer", "educator", "accounts", "support", "dspoc", "leaders"],
  },
  {
    path: "/pricing",
    component: <FacultyPricing />,
    roles: ["spoc", "accounts"],
  },
  {
    path: "/manage-trainers",
    component:<TrainerManagement />,
    roles: ["trainerspoc"],
  },
  {
    path: "/designer/upcoming-events",
    component: <UpcomingEvents defaultStatus="upcoming" />,
    roles: ["desiner", "admin"],
  },
  {
    path: "/designer/ongoing-events",
    component: <UpcomingEvents defaultStatus="ongoing" />,
    roles: ["desiner", "admin"],
  },
  {
    path: "/designer/past-events",
    component: <UpcomingEvents defaultStatus="past" />,
    roles: ["desiner", "admin"],
  },
  {
    path: "/risingstar",
    component: <RisingStar />,
    roles: ["desiner", "admin"],
  },
    {
    path: "/guide-book",
    component: <GuideBook />,
    roles: ["support"],
  },
    {
    path: "/help",
    component: <Help />,
      roles: ["admin", "staff", "spoc", "manager", "management", "educator", "account_manager", "talent", "leaders", "dspoc", "tpo", "trainer", "support", "accounts", "trainerspoc", "desiner", "corporate"],
  },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  {
    path: "*",
    component: <Navigate to="/page-not-found" />
  }
];

const publicRoutes = [
  // { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
  // { path: "/", exact: true },
  // { path: "/mcalendar", component: <CalendarApp /> },
  { path: "/scalendar", component: <StaffTrainerAvailability /> },
  { path: "/atts", component: <EventFeedbackForm /> },
  // {
  //   path: "/att/:bookingId",
  //   component: <AttendanceSystem />,
  // },
  // { path: "/admin/feedback", component: <FeedbackTables /> },

  //  { path: "/award-management", component: <AwardManagementSystem /> },
  {
    path: "e344rtyuty6/rt576/:leaderId/:categoryId",
    component: <MainCorporate />,
  },
  { path: "/tpoaward", component: <PlacementMultiStepForm /> },
  { path: "/winner", component: <WinnerBanner /> },
  { path: "/badge", component: <BadgeCard /> },
  { path: "/qr", component: <EventQRPlanner /> },
  { path: "/formbuilder", component: <FormBuilder /> },
  { path: "/award/e3454-345", component: <PersonalInfoForm /> },
  // { path: "/vote", component: <NominationVotingSystem /> },
  { path: "/page-not-found", component: <PageNotFound /> },
  { path: "/guide", component: <KnowledgeHubPage /> },
  { path: "/voting", component: <MainVotingApp /> },
  { path: "/carousel", component: <ElegantCarousel /> },

  { path: "/editor", component: <ImageEditor /> },
  {
    path: "/login",
    component: (
      <ExternalRedirect url="https://eduskillsfoundation.org/login/" />
    ),
  },
  {
    path: "*",
    component: (
      <ExternalRedirect url="https://eduskillsfoundation.org/login/" />
    ),
  },
];

// const publicRoutes = [
//    { path: "/login", component: <TailLogin /> },
//   // { path: "/interactive", component: <InteractiveIndiaMap /> },
//   { path: "/page-not-found", component: <PageNotFound /> },
//   { path: "*", component: <Navigate to="/page-not-found" /> },
// ];

export { authProtectedRoutes, publicRoutes, authProtected };
